import type { DrawingImage } from "@mnk/shared/models/drawingImage";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DownloadIcon from "@mui/icons-material/Download";
import MinusIcon from "@mui/icons-material/Remove";

interface Props {
  zoom: number;
  setZoom: (zoom: number) => void;
  currentIndex: number;
  setCurrentIndex: (index: number) => void;
  drawingImages: DrawingImage[];
  showFlag: boolean;
  setShowFlag: (showFlag: boolean) => void;
  showDownloader: boolean;
  setShowDownloader: (showDownloader: boolean) => void;
}

export const Toolbar = ({
  zoom,
  setZoom,
  currentIndex,
  setCurrentIndex,
  drawingImages,
  showFlag,
  setShowFlag,
  showDownloader,
  setShowDownloader,
}: Props) => {
  const drawingImage = drawingImages[currentIndex];

  return (
    <div className="flex flex-row justify-between items-center bg-gray-100 rounded-t-md border border-gray-300">
      <div>
        {drawingImage && (
          <p className="text-gray-700 px-4">
            {drawingImage.startKiloPost === 10000000 ? (
              <span>{drawingImage.sectionName}</span>
            ) : (
              <span>
                KP: {drawingImage.startKiloPost.toFixed(2)} 〜 {drawingImage.endKiloPost.toFixed(2)}
              </span>
            )}
          </p>
        )}
      </div>
      <div className="flex flex-row gap-4 items-center p-2">
        {drawingImages?.length && drawingImages.length > 1 && (
          <>
            <button
              type="button"
              className="px-3 py-2 border rounded-md transition-colors bg-white text-gray-700 border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
              onClick={() => setShowFlag(!showFlag)}
            >
              {showFlag ? "旗揚げを非表示にする" : "旗揚げを表示する"}
            </button>
            <button
              type="button"
              className="px-3 py-2 border rounded-md transition-colors bg-white text-gray-700 border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
              onClick={() => setCurrentIndex(currentIndex - 1)}
              disabled={currentIndex === 0}
            >
              <ArrowBackIcon className="w-4 h-4" />
            </button>
            <span className="text-gray-700 flex flex-row items-center gap-3">
              <select
                className="h-10 w-16 text-center border border-gray-300 rounded-md bg-white text-lg focus:outline-none focus:ring-2 focus:ring-blue-200 appearance-none"
                style={{ minWidth: 56, paddingRight: 24 }}
                value={currentIndex}
                onChange={(e) => setCurrentIndex(Number(e.target.value))}
              >
                {drawingImages.map((_, index) => (
                  <option key={`page-${index + 1}`} value={index}>
                    {index + 1}
                  </option>
                ))}
              </select>
              <span className="ml-2">/ {drawingImages?.length}</span>
            </span>
            <button
              type="button"
              className="px-3 py-2 border rounded-md transition-colors bg-white text-gray-700 border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
              onClick={() => setCurrentIndex(currentIndex + 1)}
              disabled={currentIndex === drawingImages.length - 1}
            >
              <ArrowForwardIcon className="w-4 h-4" />
            </button>
            <button
              type="button"
              className="px-3 py-2 border rounded-md transition-colors bg-white text-gray-700 border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
              onClick={() => setZoom(zoom - 0.01)}
            >
              <MinusIcon className="w-4 h-4" />
            </button>
            <span className="text-gray-700">{Math.round(zoom * 100)}%</span>
            <button
              type="button"
              className="px-3 py-2 border rounded-md transition-colors bg-white text-gray-700 border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
              onClick={() => setZoom(zoom + 0.01)}
            >
              <AddIcon className="w-4 h-4" />
            </button>
            <button
              type="button"
              className="px-3 py-2 border rounded-md transition-colors bg-white text-gray-700 border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
              onClick={() => setShowDownloader(!showDownloader)}
            >
              <DownloadIcon className="w-4 h-4" />
            </button>
          </>
        )}
      </div>
    </div>
  );
};
